export const convertToUtc = (date: Date): Date => {
  return new Date(
    +new Date(date) + -1 * new Date(date).getTimezoneOffset() * 60000
  )
}
